import axios from "axios";

const token = localStorage.getItem("@supply:token") || "";

axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

const apiChart = axios.create({
    baseURL: process.env.REACT_APP_API_URL_CHART_PROD,
});


export default apiChart;
